<template>
    <v-container class="grey lighten-5" fluid>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-row align="center" justify="center">
            <v-col md="8" sm="8" xs="12">
                <v-card>
                   <v-card-title class="px-3">Add User</v-card-title>
                    <v-divider></v-divider>
                    
                    <v-form ref="form" lazy-validation>
                        <v-row class="px-4 py-4 pb-2">
                            <v-col md="12" sm="12" xs="12" class="pb-0">
                                <v-autocomplete
                                    v-model="user.merchant"
                                    label="Select a merchant"
                                    :items="merchants"
                                    item-value="uuid"
                                    item-text="name"
                                    dense
                                    multiple
                                    small-chips
                                    top
                                    :rules="[merchantRule]"
                                ></v-autocomplete>
                            </v-col>

                            <v-col md="6" class="pt-0">
                                <v-text-field
                                    v-model="user.firstName"
                                    label="First Name"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" class="pt-0">
                                <v-text-field
                                    v-model="user.surname"
                                    label="Surname"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>

                            <v-col md="6" class="pt-0">
                                <v-text-field
                                    v-model="user.email"
                                    label="Email Address"
                                    :rules="[rules.required, emailRule]"
                                    :error-messages="dupeEmail"
                                ></v-text-field>
                            </v-col>

                            <v-col md="6">
                                <v-select
                                    v-model="user.role"
                                    label="Access Level"
                                    :items="userRoles"
                                    item-value="id"
                                    item-text="name"
                                    dense
                                    append-outer="mdi-search"
                                    :rules="[rules.required]"
                                    @change="merchantRule"
                                >
                                    <v-tooltip slot="append" left>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" >mdi-information-outline</v-icon>
                                        </template>
                                        <div v-for="i in userRoles" :key="i.id">
                                            <span v-if="$store.state.user.user_role.id <= 3 && i.id == 4"><br>Merchant Level Roles<br></span>
                                            {{ i.name }}: {{ i.role_desc }}
                                        </div>
                                    </v-tooltip>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="create">Create</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="result">
            <v-col md="8" offset-md="2">
                <v-alert type="success" text border="left" dismissible>
                    {{ resultDesc }}
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    beforeMount() {
        this.uri = this.state;
        this.getMerchants();
        this.getUserRoles();
        console.log(this.user);
        console.log(this.$store.state.sysState);
    },
    computed: {
        state() {
            return this.$store.state.sysState ? 'live' : 'test';
        }
    },
    watch: {
        email(v) {
            axios({
            method: 'post',
            url: 'username-check',
            data: { username: v },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.dupeEmail = response.data == 1 ? ['Username already exists'] : [];
                this.user.email = v;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        state() {
            this.uri = this.state;
            this.getMerchants();
        }
    },
    data() {
        return {
            rules: { required: v => !!v || 'Required.',
                     multiple: v => v.length == 0 ? 'Required' : true },
            user: { merchant: [] },
            userRoles: null,
            merchants: null,
            email: null,
            dupeEmail: [],
            loading: false,
            result: null,
            resultDesc: null,
            uri: null
        }
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-${this.uri}`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-${this.uri}-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.merchant = this.merchants.length == 1 ? this.merchants[0] : null;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getUserRoles() {
            axios({
                method: 'post',
                url: `get-user-roles`,
                data: { userRole: this.$store.state.user.user_role.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.userRoles = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        create() {
            if(this.$refs.form.validate()) {
                this.loading = true;
                console.log(this.user.merchant);
                this.user.merchant = this.user.merchant ? this.user.merchant : null;

                axios({
                method: 'post',
                url: `add-user`,
                data: { user: this.user, state: this.state },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    if(response.data.id) {
                        this.loading = false;
                        this.result = true;
                        this.resultDesc = 'User successfully created';
                    }
                    else {
                        this.loading = false;
                        this.result = true;
                        this.resultDesc = response.data;
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        merchantRule() {
            if(this.user.role >= 4 && this.user.merchant.length == 0) {
                return 'Required';
            }
            else {
                return true;
            }     
        }
    }
}
</script>

<style>

</style>